import { resolvable }                                from '@mathquis/modelx-resolvables';
import doc                                           from 'decorators/doc';
import model                                         from 'decorators/model';
import { Timestampable }                             from 'helpers/traits';
import { Blamable }                                  from 'helpers/traits';
import SalesPrivateApiModel                          from '../../abstracts/SalesPrivateApiModel';
import OptionTypeModel                               from './OptionTypeModel';
import QuotationModel                                from './QuotationModel';

@model.staticLabel('QuotationOptionType')
@model.urnResource('quotation_option_type')
@doc.path('/quotation_option_types/{?id}')
export default class QuotationOptionTypeModel extends Blamable(Timestampable(SalesPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'quotation': id;
		'optionType.reference': SalesOptionTypeReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
	}> = {};

	@resolvable(QuotationModel, { attributeName: 'quotation' })
	declare quotation: QuotationModel;

	@resolvable(OptionTypeModel, { attributeName: 'optionType' })
	declare optionType: OptionTypeModel;

	public get optionTypeId() {
		return this.get('optionType.id');
	}
}
